import requests from './httpService';

const ScheduleService = {
  getAllSchedule() {
    return requests.get(`/schedule/list`);
  },
  
  createSchedule(body) {
    return requests.post('/schedule/add', body); 
  },

  deleteSchedule(body) {
    return requests.delete(`/schedule/${body._id}`); 
  },

  updateSchedule(body) {
    return requests.put(`/schedule/${body._id}`, body); 
  },

  findScheduleList(body) {
    return requests.post('/schedule/find', body);
  },

  getScheduleById(id) {
    return requests.get(`/schedule/${id}`);
  },

  getRegisteredSchoolsCount() {
    return requests.get('/schedule/registered-schools-count');
  },
};

export default ScheduleService;

